export default __webpack_public_path__ + "static/media/stripe_logo.3c01f9ac.svg";